<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        <span class="headline mb-0">ロングドレー判定テーブル</span>
      </v-card-title>
      <v-card-actions>
        <v-btn
          v-permit.SHARP_LONG_DISTANCE_ROUTE_SEARCH
          @click="search()"
          class="btn-search"
          >{{ $t("app.buttons.search") }}</v-btn
        >
        <v-btn v-permit.SHARP_LONG_DISTANCE_ROUTE_NEW to="/M0300/New">{{
          $t("app.buttons.new")
        }}</v-btn>
        <v-btn
          v-permit.SHARP_LONG_DISTANCE_ROUTE_EDIT
          @click="edit()"
          :disabled="selected.length !== 1"
          >{{ $t("app.buttons.edit") }}</v-btn
        >
        <v-btn
          v-permit.SHARP_LONG_DISTANCE_ROUTE_REMOVE
          @click="remove()"
          :disabled="selected.length !== 1"
          >{{ $t("app.buttons.remove") }}</v-btn
        >
      </v-card-actions>
      <v-form>
        <v-container fluid>
          <v-layout row wrap>
            <v-flex xs3>
              <remote-autocomplete
                :label="$t('app.labels.dischargePort')"
                url="ports/kv"
                v-model="query.dischargePortCode"
              ></remote-autocomplete>
            </v-flex>
            <v-flex xs3>
              <remote-autocomplete
                label="最終納入場所"
                url="warehouses/reservable-kv"
                v-model="query.warehouseId"
              ></remote-autocomplete>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>
    <v-card class="mt-2">
      <v-data-table
        :headers="headers"
        :items="results"
        :loading="loading"
        :pagination.sync="pagination"
        :rows-per-page-items="[10]"
        :total-items="pagination.totalItems"
        item-key="id"
        select-all
        v-model="selected"
      >
        <template slot="items" slot-scope="props">
          <td>
            <v-checkbox
              hide-details
              primary
              v-model="props.selected"
            ></v-checkbox>
          </td>
          <td>
            {{
              props.item.dischargePortCode + "-" + props.item.dischargePortName
            }}
          </td>
          <td>
            {{ props.item.warehouseCode + "-" + props.item.warehouseName }}
          </td>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      selected: [],
      results: [],
      loading: false,
      pagination: {
        page: 1,
      },
      query: {},
      headers: [
        {
          text: "陸揚港",
          value: "dischargePortCode",
          sortable: false,
        },
        {
          text: "最終納入場所",
          value: "finallyWarehouseId",
          sortable: false,
        },
      ],
    };
  },

  methods: {
    params() {
      return {
        params: {
          ...this.query,
          ...this.$pageable(),
          sort: "dischargePortCode",
        },
      };
    },
    search() {
      this.pagination.page = 1;
      this.load();
    },
    load() {
      this.autoload = true;
      this.$storeParams();
      this.loading = true;
      this.$http
        .get("/long-distance-routes", this.params())
        .then((res) => {
          this.pagination.page = res.data.number + 1;
          this.pagination.rowsPerPage = res.data.size;
          this.pagination.totalItems = res.data.totalElements;
          this.results = res.data.content;
          this.loading = false;
          this.selected = [];
        })
        .catch(() => {
          this.loading = false;
        });
    },
    edit() {
      this.$router.push({
        path: "M0300/edit",
        query: {
          id: this.selected[0].id,
        },
      });
    },
    remove() {
      this.$confirm({
        content: this.$t("app.messages.removeConfirm"),
      }).then(() => {
        this.$http
          .delete(`/long-distance-routes/${this.selected[0].id}`)
          .then(() => {
            this.load();
            this.$message("", this.$t("app.messages.removeSuccess"));
            this.selected = [];
          });
      });
    },
  },
  watch: {
    pagination() {
      if (this.autoload) this.load();
    },
  },
  mounted() {
    this.$loadParams();
  },
};
</script>
